export default "__VITE_ASSET__B9xP9VI9__"